<app-merchant *ngIf="english"></app-merchant>
<app-merchant-hindi *ngIf="hindi"></app-merchant-hindi>